// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"aa17f0af","44":"f76b1b26","263":"dc321ddf","294":"b342abbe","307":"5ee203fe","651":"af07c009","729":"9135e59d","850":"1f6e66e1","881":"0af5cec1","949":"4ab09ce2"}[chunkId] + ".chunk.js";
};